{
  "supported": ["en", "nl", "de", "it", "es"],
  "default": "en",
  "provisional": ["de", "it", "es"]
}
